import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import AlertDialogAddResource from '../../../common/AlertDialog/alertAddUser';
import AlertRemoveReportResource from '../../../common/AlertDialog/alertRemoveReportResource';
import {isEmptyVariable,isEmptyArray,
    getLocalStorageVariables,
    handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {ResouceAddButton,ResouceRemoveButton} from '../../../common/Global/globalStyles.style';
import AlertDialog from '../../../common/AlertDialog';

let userDetails = {};

class AssignResourcesCompEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,
            totalCount:0,
            currentPageNo: 1,
            selectedL0User:{},
            selectedL1User:{},
            selectedL2User:{},
            selectedL3User:{},
            selectedL4User:{},
            selectedL5User:{},
            createResourceResponse:"",

            showRemoveReportDialog:false,
            removeUserId:"",
            removeUserName:"",

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
        }
    }

    componentDidMount(){
        userDetails = getLocalStorageVariables();
        this.getEditInitData();
    }

    handleAlertDialogCloseInfo = () =>{
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    handleRemoveAlertDialogShow = (user) => {
        if(this.state.addedResources.length === 1){
            this.setState({
                showRemoveReportDialog:true,
                removeUserId:user.userId,
                removeUserName:user.fullName,
            });
        }else{
            this.handleDirectRemove(user.userId);
        }
    }

    handleRemoveReportDialogClose = (reloadFlag) => {
        this.setState({
            showRemoveReportDialog:false,
            removeUserId:"",
            removeUserName:"",
        },()=>{
            if(reloadFlag === true) this.getEditInitData();
        });
    }

    handleDirectRemove = (removeUserId) => {
        userDetails = getLocalStorageVariables();
        fetch(Constants.RemoveReportResource,{
            method:"POST",
            mode:"cors",
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                assignmentId:this.props.assignmentId,
                removeUserId:removeUserId,
                replaceUserId:"",
            })
        })
        .then(res => res.json())
        .then(res => {
            if(handleTokenExpiry(res.responseCode)) return;
            if(res.responseCode === Constants.CODE_SUCCESS){
                this.getEditInitData();
            }else{
                this.setState({
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:res.responseMessage
                });
            }
        });
    }

    handleAddAlertDialogShow = (level) => {
        this.setState({
            showAddAlertDialog:true,
            alertDialogHeading:"Add Resource",
            proceedBtnLabel:"Add",
            addUserLevel:level,
        })
    }

    handleAddAlertDialogClose = (reloadFlag) => {
        this.setState({
            showAddAlertDialog:false,
            alertDialogHeading:"",
            proceedBtnLabel:"",
            addUserLevel:"",
        },()=>{
            if(reloadFlag === true) this.getEditInitData();
        })
    }

    getEditInitData = () => {
        this.setState({
            showLoader:true,
        });

        Promise.all([
            fetch(Constants.GetAssignedReportResources,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentId:this.props.assignmentId,
                })
            }),
            fetch(Constants.AssignResourceMasterData,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentId:this.props.assignmentId,
                })
            })
        ])
        .then(([assignedRes,masterRes]) => {
            return Promise.all([assignedRes.json(),masterRes.json()])
        })
        .then(([assignedRes,masterRes]) => {
            let datalist =[];
            let assignmentReportReviewMatrix =[];
            let assignmentMemberMatrix =[];

            if(handleTokenExpiry(assignedRes.responseCode)) return;
            else if(assignedRes.responseCode === Constants.CODE_SUCCESS){
                assignmentReportReviewMatrix = assignedRes.data.assignedReportResources;
            }else{
            }

            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if(masterRes.responseCode === Constants.CODE_SUCCESS){
                datalist = masterRes.data.users;
            }else{
            }

            let selectedReviewUsers = {
                selectedL0User:{},
                selectedL1User:{},
                selectedL2User:{},
                selectedL3User:{},
                selectedL4User:{},
                selectedL5User:{},
            }

            let finalDataList = [];

            if(isEmptyArray(assignmentReportReviewMatrix)){
                finalDataList = datalist;
            }else{
                    finalDataList = datalist.map(item=>{
                        let itemNew = item;
                        for(const [index,value] of assignmentReportReviewMatrix.entries()){
                            selectedReviewUsers["selectedL"+value.level+"User"] = value;
                            if(value.userId+"" === item.userId+""){
                                itemNew.isSelected = true;
                                itemNew.position = "L"+value.level;
                                itemNew.status = value.status;
                            }
                        }
                        return itemNew;
                    })
            }

            let remainingResources = finalDataList.filter(item=>item.isSelected !== true || item.status=="Inactive");
            let addedResources = finalDataList.filter(item=>item.isSelected === true && item.status === "Active");

            this.setState({
                componentDidMountFlag:true,
                showLoader:false,

                assignmentMemberMatrix:assignmentMemberMatrix,

                remainingResources:remainingResources,
                addedResources:addedResources,

                ...selectedReviewUsers
            })
        })
    }

    render() {
        return(
            <>
            <div className="modal-body">
                {
                    this.state.showLoader &&
                    <div class="loader"></div>
                }

                {
                    this.state.componentDidMountFlag &&
                    <div className="row custom-row">
                    {
                        [0,1,2,3].map(item=>{
                            let userObj = this.state["selectedL"+item+"User"];
                            if(!isEmptyVariable(userObj?.userId)){
                                return <div className="col-md-6 custom-col reassign-layout">
                                    <p className='heading'>
                                        {"Review Level "+(item+1)}
                                    </p>
                                    <div className='flex-center-layout just-space-between m-b-10'>
                                        {
                                            userObj.status === "Inactive" ?
                                            <p style={{opacity:0.7}}><i>Not Assigned</i></p>
                                            :<p>{userObj.fullName}</p>
                                        }
                                        {
                                            userObj.status === "Active" &&
                                            <ResouceRemoveButton
                                            themeSettings={this.props.themeSettings}
                                            onClick={this.handleRemoveAlertDialogShow.bind(this,userObj,"L"+item)}>
                                                Remove
                                            </ResouceRemoveButton>
                                        }
                                        {
                                            userObj.status === "Inactive" &&
                                            <ResouceAddButton
                                            themeSettings={this.props.themeSettings}
                                            onClick={this.handleAddAlertDialogShow.bind(this,"L"+item)}
                                            >
                                                Add
                                            </ResouceAddButton>
                                        }
                                    </div>
                                    {
                                        !isEmptyVariable(userObj.origUserId) &&
                                        <div className='flex-center-layout just-space-between m-b-10'>
                                            <p>
                                                {userObj.origUserName+"("+userObj.origDesignation+")"}
                                                <span style={{background:"#ddd",color:"#111",display:"inline-block"}}
                                                className="span-tag">
                                                    Removed
                                                </span>
                                            </p>
                                        </div>
                                    }
                                </div>
                            }else{
                                return <div className="col-md-6 custom-col reassign-layout">
                                    <p className='heading'>
                                        {"Review Level "+(item+1)}
                                    </p>
                                    <div className='flex-center-layout just-space-between m-b-10'>
                                        <p style={{opacity:0.7}}><i>Not Assigned</i></p>
                                        <ResouceAddButton
                                        themeSettings={this.props.themeSettings}
                                        onClick={this.handleAddAlertDialogShow.bind(this,"L"+item)}
                                        >
                                            Add
                                        </ResouceAddButton>
                                    </div>

                                </div>
                            }
                        })
                    }
                    </div>
                }
            </div>

            <AlertRemoveReportResource
                showAlertDialog={this.state.showRemoveReportDialog}
                handleAlertDialogClose={this.handleRemoveReportDialogClose}
                removeUserId={this.state.removeUserId}
                removeUserName={this.state.removeUserName}
                usersList={this.state.remainingResources}
                assignmentId={this.props.assignmentId}
            />

            <AlertDialogAddResource
                showAlertDialog={this.state.showAddAlertDialog}
                alertDialogHeading={this.state.alertDialogHeading}
                proceedBtnLabel={this.state.proceedBtnLabel}
                usersList={this.state.remainingResources}
                addUserLevel={this.state.addUserLevel}
                handleAlertDialogClose={this.handleAddAlertDialogClose}
                assignmentId = {this.props.assignmentId}
                resourceAssignmentType = {"Report"}
                themeSettings={this.props.themeSettings}
            />
            <AlertDialog 
                showAlertDialog={this.state.showAlertDialogInfo}
                handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                type= {Constants.ALERT_TYPE_ALERT}
                alertDialogMessage={this.state.alertDialogMessageInfo}
                proceedBtnClick={this.handleAlertDialogCloseInfo}
                proceedBtnLabel={ Constants.ALERT_TYPE_OKAY_LABEL }
                themeSettings={this.props.themeSettings}
            />
            </>
        );
    }
}

export default AssignResourcesCompEdit;